<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm_head">Contents</h2>
<p class="con"><a href="#/text/9780062899897_Cover#cover" id="rcover"><i>Cover</i></a></p>
<p class="con"><a href="#/text/9780062899897_Titlepage#title" id="rtitle"><i>Title Page</i></a></p>
<p class="con1"><a href="#/text/9780062899897_Chapter_1">Begin Reading</a></p>
<p class="con1"><span href="#/text/About_the_Author#_idParaDest-1" id="r_idParaDest-1" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="con"><span href="#/text/9780062899897_Also_by#_idParaDest-2" id="r_idParaDest-2" title="Link target outside of Sample"><i>Also by Olaf Olafsson</i></span></p>
<p class="con"><span href="#/text/9780062899897_Copyright#_idParaDest-3" id="r_idParaDest-3" title="Link target outside of Sample"><i>Copyright</i></span></p>
<p class="con"><span href="#/text/About_the_Publisher#_idParaDest-4" id="r_idParaDest-4" title="Link target outside of Sample"><i>About the Publisher</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062899897_Contents.vue?27fc2994